import { render } from "./CreateProductModal.vue?vue&type=template&id=3f402eae&scoped=true"
import script from "./CreateProductModal.vue?vue&type=script&lang=js"
export * from "./CreateProductModal.vue?vue&type=script&lang=js"

import "./CreateProductModal.vue?vue&type=style&index=0&id=3f402eae&lang=css"
import "./CreateProductModal.vue?vue&type=style&index=1&id=3f402eae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f402eae"]])

export default __exports__